import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/consult';
import List from '../../List/List';
import {RECORD} from "../../../../../utility/variables";
import {resetStore} from "../../../../../redux/modules/login";


const ms2p = (state) => {
    return {
        ...state.consult,
        titulo: 'ANTECEDENTES',
        show_list: RECORD,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(List);
